import { ArrowLeft, ExternalLink } from 'lucide-react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import type { Opportunity } from '../../types/internal-opportunity.types';
import { STATUS_CONFIG, DECISION_CONFIG } from '../../types/internal-opportunity.types';

interface OpportunityHeaderProps {
  opportunity: Opportunity;
}

export function OpportunityHeader({ opportunity }: OpportunityHeaderProps) {
  const statusConfig = STATUS_CONFIG[opportunity.status];
  const decisionConfig = opportunity.decision
    ? DECISION_CONFIG[opportunity.decision]
    : null;

  return (
    <div className="space-y-4">
      {/* Navigation */}
      <div className="flex items-center gap-4">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/tm/opportunities">
            <ArrowLeft className="h-4 w-4 mr-2" />
            Retour à la liste
          </Link>
        </Button>
      </div>

      {/* Titre et badges */}
      <div className="flex flex-col lg:flex-row lg:items-start lg:justify-between gap-4">
        <div className="space-y-2">
          <div className="flex items-center gap-2 flex-wrap">
            <Badge className={`${statusConfig.color} ${statusConfig.bgColor}`}>
              {statusConfig.label}
            </Badge>
            {decisionConfig && (
              <Badge className={`${decisionConfig.color} ${decisionConfig.bgColor}`}>
                {decisionConfig.label}
              </Badge>
            )}
            {opportunity.importSource && (
              <Badge variant="outline" className="border-copper text-copper">
                {opportunity.importSource.toUpperCase()}
              </Badge>
            )}
            {opportunity.noticeNature === 'AVIS_RECTIFICATIF' && (
              <Badge variant="outline" className="border-amber-500 bg-amber-50 text-amber-700">
                Rectificatif
              </Badge>
            )}
            {opportunity.reference && (
              <span className="text-sm text-muted-foreground">
                Réf: {opportunity.reference}
              </span>
            )}
          </div>
          <h1 className="text-2xl font-bold">{opportunity.title}</h1>
          {opportunity.shortTitle && opportunity.shortTitle !== opportunity.title && (
            <p className="text-muted-foreground">{opportunity.shortTitle}</p>
          )}
        </div>

        {opportunity.sourceUrl && (
          <Button variant="outline" asChild>
            <a
              href={opportunity.sourceUrl}
              target="_blank"
              rel="noopener noreferrer"
            >
              <ExternalLink className="h-4 w-4 mr-2" />
              Voir l'avis original
            </a>
          </Button>
        )}
      </div>
    </div>
  );
}
